<template>
  <div>
    <el-container>
      <el-header>
        <head_page :head_page_type="false" ref="head_page"></head_page>
      </el-header>
      <el-main>
        <div id='choose_city' v-loading="loading" v-bind:element-loading-text="$t('message.Desperately_loading')"
          element-loading-spinner="el-icon-loading" element-loading-background="rgba(0, 0, 0, 0.8)">
          <head_menu :has-back=true @go-back-click="goBack" :has-next=true @go-next-click="goNext">
            <template #title>
              <div style="text-align:center;background-color: #F0F0EE;color:#53ADBC;padding:10px;font-size: 20px;">
                {{chosen_city_shown}}
              </div>
            </template>
          </head_menu>
          <!--
          <div style="text-align: left;">
            <el-row>
              <el-col :span="8" style="background-color: #F0F0EE;">
                <el-button-group>
                  <el-button icon="el-icon-d-arrow-left" @click="goBack" style="background-color: #f3f3f4;"></el-button>
                  <el-button icon="el-icon-s-home" @click="goHome" style="background-color: #e9e9ea;"></el-button>
                  <el-button icon="el-icon-d-arrow-right" @click="goNext" style="background-color: #f3f3f4;"></el-button>
                </el-button-group>
              </el-col>
              <el-col :span="6" style="text-align:center;background-color: #F0F0EE;color:#53ADBC;padding:10px;font-size: 20px;">
                {{chosen_city_shown}}
              </el-col>
              <el-col :span="10" style="text-align: right;background-color: #F0F0EE;">
              </el-col>
            </el-row>
          </div>
          -->
        

          <!--<div class="first-line" style="display:flex;align-items:flex-start;justify-items:space-between">-->
          <el-row type="flex" :gutter="20">
            <!--<div style="text-align: left;width:30%" id="selected_criterias">-->
            <el-col :span="8" style="background: white; background-clip: content-box; border-radius: 0; padding-left: 30px;">
              <div style="text-align: left; margin-top: 10px;" id ='selected_criterias'>
                <el-row :gutter="10" style="margin: 15px">
                  <el-col :span="7">
                    <p class="p9">{{ $t("message.Gender") }}:</p>
                  </el-col>
                  <el-col :span="17">
                    <p class="p10">{{ gender }}</p>
                  </el-col>
                </el-row>

                <el-row :gutter="10" style="margin: 15px">
                  <el-col :span="7">
                    <p class="p9">{{ $t("message.Age") }}:</p>
                  </el-col>
                  <el-col :span="17">
                    <p class="p10">{{ age }}</p>
                  </el-col>
                </el-row>
                <el-row :gutter="10" style="margin: 15px">
                  <el-col :span="7">
                    <p class="p9">{{ $t("message.Spend_Power") }}:</p>
                  </el-col>
                  <el-col :span="17">
                    <p class="p10">{{ spend_power }}</p>
                  </el-col>
                </el-row>
                <el-row :gutter="10" style="margin: 15px">
                  <el-col :span="7">
                    <p class="p9">{{ $t("message.Interests") }}:</p>
                  </el-col>
                  <el-col :span="17">
                    <p class="p10">{{ interest }}</p>
                  </el-col>
                </el-row>
                <el-row :gutter="10" style="margin: 15px">
                  <el-col :span="7">
                    <p class="p9">{{ $t("message.POI") }}:</p>
                  </el-col>
                  <el-col :span="17">
                    <p class="p10">{{ poi }}</p>
                  </el-col>
                </el-row>
                <el-row :gutter="10" style="margin: 15px">
                  <el-col :span="7">
                    <p class="p9">{{ $t("message.Media_Format") }}:</p>
                  </el-col>
                  <el-col :span="17">
                    <p class="p10">{{ media_type }}</p>
                  </el-col>
                </el-row>
                <el-row :gutter="10" style="margin: 15px">
                  <el-col :span="7">
                    <p class="p9">{{ $t("message.Rank") }}:</p>
                  </el-col>
                  <el-col :span="17">
                    <p class="p10">{{ rank }}</p>
                  </el-col>
                </el-row>
                <el-row :gutter="10" style="margin: 15px">
                  <el-col :span="7">
                    <p class="p9">{{ $t("message.Nearby_Location") }}:</p>
                  </el-col>
                  <el-col :span="17">
                    <p class="p10">{{ poi_ba_label_selection_list }}</p>
                  </el-col>
                </el-row>
              </div>
            </el-col>
            <!--</div>-->
            <div v-if="false" style="visible:none;text-align: left;width:20%;margin:3.5%;margin-right:5%;margin-left:-2%;">
              <el-table :data="this.summaryTable">
                <el-table-column label="">
                  <template slot-scope="scope" style="text-align: center">{{
                    scope.row.name
                  }}</template>
                </el-table-column>
                <el-table-column>
                  <template slot="header" slot-scope="scope">
                    <span>{{ $t("message.Num_of_POI") }}</span>
                  </template>

                  <template slot-scope="scope" style="text-align: center">{{
                    scope.row.line_qty
                  }}</template>
                </el-table-column>
              </el-table>
            </div>
            <!--<div style="text-align: center;width:60%">-->
            <el-col :span="16" style="background: white; background-clip: content-box; border-radius: 0; padding-right: 30px;">
              <div style="width:100%;">
                <div style="padding: 5px;font-size: 18px;color:#254A6E;font-weight: 600;">
                            <span>{{$t('message.Campaign_Starting_Date')}} {{this.campaignDate_YYMMDD}}</span>
                            <span style="margin-left:15px"
                            >{{$t('message.Duration(Months)')}} : {{this.campaignDuration}}</span>
                </div>
              </div>
            
              <div style="text-align: left;width:100%;border: 1px solid #e9e9ea;">
                <el-table :data="this.summaryTable" show-summary :summary-method="getSummaries" sum-text="$t('message.summary')"> 
                  <el-table-column label="">
                    <template slot-scope="scope" style="text-align: center">{{
                      scope.row.name
                    }}</template>
                  </el-table-column>
                  <el-table-column :label="$t('message.Bus_Line_Qty')" prop="line_qty" >
                  </el-table-column>
                  <el-table-column :label="$t('message.Bus_Body_Qty')" prop="body_qty">
                  </el-table-column>
                  <el-table-column :label="$t('message.Viewed_Impression')" prop="impression" :formatter="stateFormat">
                  </el-table-column>
                  <el-table-column :label="$t('message.Viewed_Impression(Audience)')" prop="cluster_impression" :formatter="stateFormat">
                  </el-table-column>
                </el-table>
              </div>
            </el-col>
            <!--</div>-->
          </el-row>
          <!--</div>-->
          <div class="second-line" style="margin-top:20px;">
            <el-select v-model="value_bus_line_total" filterable :placeholder="$t('message.Please_Select')" @change="handleBusLineTotalChange">
              <el-option
                v-for="item in busLineTotal"
                :key="item.bus_id"
                :label='
                        $i18n.locale == "en" ? item.bus_name.replace("Line", "").replace("路", "").replace("高峰快巴", "Peak Express ").replace("高峰专线", "Peak Line ")
                          : item.bus_name.replace("Line", "").replace("路", "")'
                :value="item.bus_id">
              </el-option>
            </el-select>
            <el-button @click="localte">{{$t('message.locate')}}</el-button>
            <b-tabs  fill v-model="tabIndex" style="margin: 10px 20px 20px 20px">
              <b-tab :title="$t('message.Top_125+')" active>
                <div style="width:100%;margin-bottom:10px">
                  <b-row class="text-center">
                    <b-col cols="2">
                      <!-- 
                      <el-select v-model="value_bus_line_top" filterable placeholder="请选择" @change="handleBusLineTopChange">
                        <el-option
                          v-for="item in busLineTop"
                          :key="item.bus_id"
                          :label="item.bus_name"
                          :value="item.bus_id">
                        </el-option>
                      </el-select>
                       -->
                    </b-col>
                    <b-col cols="7"></b-col>
                    <b-col cols="3">
                      <el-input style="display:inline-block;width:200px" v-model="num"></el-input>
                      <el-button style="display:inline-block" type="primary" plain @click="handleBulk('top')">{{ $t("message.Bulk") }}</el-button>
                    </b-col>
                  </b-row>
                  <el-table
                    :data="this.busLineTop"
                    @selection-change="handleSelectionChangeTop"
                    max-height="600"
                    border
                    ref="multipleTableTop"
                  >
                    <el-table-column type="selection"> </el-table-column>
                    <el-table-column label="Bus">
                      <template slot="header" slot-scope="scope">
                        <span class="hearder_span">{{ $t("message.Bus") }}</span>
                      </template>
                      <template slot-scope="scope" style="text-align: center">
                         <el-tooltip
                        class="item"
                        effect="dark"
                        :content="'剩余 ' + Number(scope.row.hub_valid_bus_body || 'N/A') +' 台'"
                        placement="top"
                     ><span>{{
                        $i18n.locale == "en" ? scope.row.bus_name.replace("Line", "").replace("路", "").replace("高峰快巴", "Peak Express ").replace("高峰专线", "Peak Line ")
                          : scope.row.bus_name.replace("Line", "").replace("路", "")
                      }}</span></el-tooltip>
                      <a :name="scope.row.bus_id"></a>
                      </template>
                    </el-table-column>
                    <el-table-column label="Vendor">
                      <template slot="header" slot-scope="scope">
                        <span class="hearder_span">{{ $t("message.vendor") }}</span>
                      </template>
                      <template slot-scope="scope" style="text-align: center">{{
                        scope.row.vendor_name
                      }}</template>
                    </el-table-column>
                    <el-table-column label="POI">
                      <template slot="header" slot-scope="scope">
                        <span class="hearder_span">{{ $t("message.Related_Location_Number") }}</span>
                      </template>
                      <template slot-scope="scope" style="text-align: center">{{
                        scope.row.related_poi_nb
                      }}</template>
                    </el-table-column>
                    <el-table-column>
                      <template slot="header" slot-scope="scope">
                        <span class="hearder_span">{{ $t("message.index2") }}</span>
                      </template>
                      <template slot-scope="scope" style="text-align: center">{{
                        Number(scope.row.value_rating * 100).toFixed(0)
                      }}</template>
                    </el-table-column>
                    <el-table-column>
                      <template slot="header" slot-scope="scope">
                        <span class="hearder_span">{{ $t("message.Grading") }}</span>
                      </template>
                      <template slot-scope="scope" style="text-align: center">{{
                        scope.row.rank_tag
                      }}</template>
                    </el-table-column>
                    <el-table-column>
                      <template slot="header" slot-scope="scope">
                        <span class="hearder_span">{{ $t("message.Viewed_Impression") }}</span>
                      </template>
                      <template slot-scope="scope" style="text-align: center">{{
                        Math.round((scope.row.IMP * scope.row.body_qty * repeatRatio(scope.row.body_qty))).toLocaleString('en-US')
                      }}</template>
                    </el-table-column>
                    <el-table-column>
                      <template slot="header" slot-scope="scope">
                        <span class="hearder_span">{{ $t("message.Viewed_Impression(Audience)") }}</span>
                      </template>
                      <template slot-scope="scope" style="text-align: center">{{
                        Math.round((scope.row.target_IMP * scope.row.body_qty * repeatRatio(scope.row.body_qty))).toLocaleString('en-US')
                      }}</template>
                    </el-table-column>
                    <el-table-column label="Bus body (qty)">
                      <template slot="header" slot-scope="scope">
                        <span class="hearder_span">{{ $t("message.Bus_body(qty)") }}</span>
                      </template>
                      <template slot-scope="scope">
                        <el-input-number size="mini" style="width:100px" v-model="scope.row.body_qty" @change="handleChange(scope.row.body_qty,scope.row,'top')" :min="1" :max="20"></el-input-number>
                      </template>
                    </el-table-column>
                  </el-table>
                </div>
              </b-tab>
              <b-tab :title="$t('message.Avg+_125_100')">
                <div style="width:100%;margin-bottom:10px">
                  <b-row class="text-center">
                    <b-col cols="2">
                      <!-- 
                      <el-select v-model="value_bus_line_medium_up" filterable placeholder="请选择" @change="handleBusLineTopChange">
                        <el-option
                          v-for="item in busLineMediumUp"
                          :key="item.bus_id"
                          :label="item.bus_name"
                          :value="item.bus_id">
                        </el-option>
                      </el-select>
                      -->
                    </b-col>
                    <b-col cols="7"></b-col>
                    <b-col cols="3">
                      <el-input style="display:inline-block;width:200px" v-model="num"></el-input>
                      <el-button style="display:inline-block" type="primary" plain @click="handleBulk('mediumUp')">{{ $t("message.Bulk") }}</el-button>
                    </b-col>
                  </b-row>
                  <el-table
                  :data="this.busLineMediumUp"
                  @selection-change="handleSelectionChangeMediumUp"
                  max-height="600"
                  border
                  ref="multipleTableMediumUp"
                  >
                    <el-table-column type="selection"> </el-table-column>
                    <el-table-column label="Bus">
                      <template slot="header" slot-scope="scope">
                        <span class="hearder_span">{{ $t("message.Bus") }}</span>
                      </template>
                      <template slot-scope="scope" style="text-align: center">
                        <el-tooltip
                        class="item"
                        effect="dark"
                        :content="'剩余 ' + Number(scope.row.hub_valid_bus_body || 'N/A') +' 台'"
                        placement="top"
                     ><span>{{
                        $i18n.locale == "en" ? scope.row.bus_name.replace("Line", "").replace("路", "").replace("高峰快巴", "Peak Express ").replace("高峰专线", "Peak Line ")
                          : scope.row.bus_name.replace("Line", "").replace("路", "")
                      }}</span></el-tooltip>
                      <a :name="scope.row.bus_id"></a>
                      </template>
                    </el-table-column>
                    <el-table-column label="Vendor">
                      <template slot="header" slot-scope="scope">
                        <span class="hearder_span">{{ $t("message.vendor") }}</span>
                      </template>
                      <template slot-scope="scope" style="text-align: center">{{
                        scope.row.vendor_name
                      }}</template>
                    </el-table-column>
                    <el-table-column label="POI" >
                      <template slot="header" slot-scope="scope">
                        <span class="hearder_span">{{ $t("message.Related_Location_Number") }}</span>
                      </template>
                      <template slot-scope="scope" style="text-align: center">{{
                        scope.row.related_poi_nb
                      }}</template>
                    </el-table-column>
                    <el-table-column label="Index">
                      <template slot="header" slot-scope="scope">
                        <span class="hearder_span">{{ $t("message.index2") }}</span>
                      </template>
                      <template slot-scope="scope" style="text-align: center">{{
                        Number(scope.row.value_rating * 100).toFixed(0)
                      }}</template>
                    </el-table-column>
                    <el-table-column label="Grading">
                      <template slot="header" slot-scope="scope">
                        <span class="hearder_span">{{ $t("message.Grading") }}</span>
                      </template>
                      <template slot-scope="scope" style="text-align: center">{{
                        scope.row.rank_tag
                      }}</template>
                    </el-table-column>
                    <el-table-column label="Viewed impression">
                      <template slot="header" slot-scope="scope">
                        <span class="hearder_span">{{ $t("message.Viewed_Impression") }}</span>
                      </template>
                      <template slot-scope="scope" style="text-align: center">{{
                        Math.round((scope.row.IMP * scope.row.body_qty * repeatRatio(scope.row.body_qty))).toLocaleString('en-US')
                      }}</template>
                    </el-table-column>
                    <el-table-column>
                      <template slot="header" slot-scope="scope">
                        <span class="hearder_span">{{ $t("message.Viewed_Impression(Audience)") }}</span>
                      </template>
                      <template slot-scope="scope" style="text-align: center">{{
                        Math.round((scope.row.target_IMP * scope.row.body_qty * repeatRatio(scope.row.body_qty))).toLocaleString('en-US')
                      }}</template>
                    </el-table-column>
                    <el-table-column label="Bus body (qty)">
                      <template slot="header" slot-scope="scope">
                        <span class="hearder_span">{{ $t("message.Bus_body(qty)") }}</span>
                      </template>
                      <template slot-scope="scope">
                        <el-input-number size="mini" v-model="scope.row.body_qty" @change="handleChange(scope.row.body_qty,scope.row,'mediumUp')" :min="1" :max="20"></el-input-number>
                      </template>
                    </el-table-column>
                  </el-table>
                </div>
              </b-tab>
              <b-tab :title="$t('message.Avg-_100_75')">
                <div style="width:100%;margin-bottom:10px">
                  <b-row class="text-center">
                    <b-col cols="2">
                      <!-- <el-select v-model="value_bus_line_medium_down" filterable placeholder="请选择" @change="handleBusLineTopChange">
                        <el-option
                          v-for="item in busLineMediumDown"
                          :key="item.bus_id"
                          :label="item.bus_name"
                          :value="item.bus_id">
                        </el-option>
                      </el-select> -->
                    </b-col>
                    <b-col cols="7"></b-col>
                    <b-col cols="3">
                      <el-input style="display:inline-block;width:200px" v-model="num"></el-input>
                      <el-button style="display:inline-block" type="primary" plain @click="handleBulk('mediumDown')">{{ $t("message.Bulk") }}</el-button>
                    </b-col>
                  </b-row>
                  <el-table
                    :data="this.busLineMediumDown"
                    @selection-change="handleSelectionChangeMediumDown"
                    max-height="600"
                    border
                    ref="multipleTableMediumDown"
                  >
                    <el-table-column type="selection"> </el-table-column>
                    <el-table-column label="Bus">
                      <template slot="header" slot-scope="scope">
                        <span class="hearder_span">{{ $t("message.Bus") }}</span>
                      </template>
                      <template slot-scope="scope" style="text-align: center">
                        <el-tooltip
                        class="item"
                        effect="dark"
                        :content="'剩余 ' + Number(scope.row.hub_valid_bus_body || 'N/A') +' 台'"
                        placement="top"
                     ><span>{{
                        $i18n.locale == "en" ? scope.row.bus_name.replace("Line", "").replace("路", "").replace("高峰快巴", "Peak Express ").replace("高峰专线", "Peak Line ")
                          : scope.row.bus_name.replace("Line", "").replace("路", "")
                      }}</span></el-tooltip>
                      <a :name="scope.row.bus_id"></a>
                      </template>
                    </el-table-column>
                    <el-table-column label="Vendor">
                      <template slot="header" slot-scope="scope">
                        <span class="hearder_span">{{ $t("message.vendor") }}</span>
                      </template>
                      <template slot-scope="scope" style="text-align: center">{{
                        scope.row.vendor_name
                      }}</template>
                    </el-table-column>
                    <el-table-column label="POI">
                      <template slot="header" slot-scope="scope">
                        <span class="hearder_span">{{ $t("message.Related_Location_Number") }}</span>
                      </template>
                      <template slot-scope="scope" style="text-align: center">{{
                        scope.row.related_poi_nb
                      }}</template>
                    </el-table-column>
                    <el-table-column label="Index">
                      <template slot="header" slot-scope="scope">
                        <span class="hearder_span">{{ $t("message.index2") }}</span>
                      </template>
                      <template slot-scope="scope" style="text-align: center">{{
                        Number(scope.row.value_rating * 100).toFixed(0)
                      }}</template>
                    </el-table-column>
                    <el-table-column label="Grading">
                      <template slot="header" slot-scope="scope">
                        <span class="hearder_span">{{ $t("message.Grading") }}</span>
                      </template>
                      <template slot-scope="scope" style="text-align: center">{{
                        scope.row.rank_tag
                      }}</template>
                    </el-table-column>
                    <el-table-column label="Viewed impression">
                      <template slot="header" slot-scope="scope">
                        <span class="hearder_span">{{ $t("message.Viewed_Impression") }}</span>
                      </template>
                      <template slot-scope="scope" style="text-align: center">{{
                        Math.round((scope.row.IMP * scope.row.body_qty * repeatRatio(scope.row.body_qty))).toLocaleString('en-US')
                      }}</template>
                    </el-table-column>
                    <el-table-column>
                      <template slot="header" slot-scope="scope">
                        <span class="hearder_span">{{ $t("message.Viewed_Impression(Audience)") }}</span>
                      </template>
                      <template slot-scope="scope" style="text-align: center">{{
                        Math.round((scope.row.target_IMP * scope.row.body_qty * repeatRatio(scope.row.body_qty))).toLocaleString('en-US')
                      }}</template>
                    </el-table-column>
                    <el-table-column label="Bus body (qty)"> 
                      <template slot="header" slot-scope="scope">
                        <span class="hearder_span">{{ $t("message.Bus_body(qty)") }}</span>
                      </template>
                      <template slot-scope="scope">
                        <el-input-number size="mini" v-model="scope.row.body_qty" @change="handleChange(scope.row.body_qty,scope.row,'mediumDown')" :min="1" :max="20"></el-input-number>
                      </template>
                    </el-table-column>
                  </el-table>
                </div>
              </b-tab>
              <b-tab :title="$t('message.Low_75-')">
                <div style="width:100%;margin-bottom:10px">

                  <b-row class="text-center">
                    <b-col cols="2">
                      <!-- 
                      <el-select v-model="value_bus_line_low" filterable placeholder="请选择" @change="handleBusLineTopChange">
                        <el-option
                          v-for="item in busLineLow"
                          :key="item.bus_id"
                          :label="item.bus_name"
                          :value="item.bus_id">
                        </el-option>
                      </el-select>
                       -->
                    </b-col>
                    <b-col cols="7"></b-col>
                    <b-col cols="3">
                      <el-input style="display:inline-block;width:200px" v-model="num"></el-input>
                      <el-button style="display:inline-block" type="primary" plain @click="handleBulk('low')">{{ $t("message.Bulk") }}</el-button>
                    </b-col>
                  </b-row>

                  <el-table
                    :data="this.busLineLow"
                    @selection-change="handleSelectionChangeLow"
                    max-height="600"
                    border
                    ref="multipleTableLow"
                  >
                    <el-table-column type="selection"> </el-table-column>
                    <el-table-column label="Bus">
                      <template slot="header" slot-scope="scope">
                        <span class="hearder_span">{{ $t("message.Bus") }}</span>
                      </template>
                      <template slot-scope="scope" style="text-align: center">
                        <el-tooltip
                        class="item"
                        effect="dark"
                        :content="'剩余 ' + Number(scope.row.hub_valid_bus_body || 'N/A') +' 台'"
                        placement="top"
                     ><span>{{
                        $i18n.locale == "en" ? scope.row.bus_name.replace("Line", "").replace("路", "").replace("高峰快巴", "Peak Express ").replace("高峰专线", "Peak Line ")
                          : scope.row.bus_name.replace("Line", "").replace("路", "")
                      }}</span></el-tooltip>
                      <a :name="scope.row.bus_id"></a>
                      </template>
                    </el-table-column>
                    <el-table-column label="Vendor">
                      <template slot="header" slot-scope="scope">
                        <span class="hearder_span">{{ $t("message.vendor") }}</span>
                      </template>
                      <template slot-scope="scope" style="text-align: center">{{
                        scope.row.vendor_name
                      }}</template>
                    </el-table-column>
                    <el-table-column label="POI">
                      <template slot="header" slot-scope="scope">
                        <span class="hearder_span">{{ $t("message.Related_Location_Number") }}</span>
                      </template>
                      <template slot-scope="scope" style="text-align: center">{{
                        scope.row.related_poi_nb
                      }}</template>
                    </el-table-column>
                    <el-table-column label="Index">
                      <template slot="header" slot-scope="scope">
                        <span class="hearder_span">{{ $t("message.index2") }}</span>
                      </template>
                      <template slot-scope="scope" style="text-align: center">{{
                        Number(scope.row.value_rating * 100).toFixed(0)
                      }}</template>
                    </el-table-column>
                    <el-table-column label="Grading">
                      <template slot="header" slot-scope="scope">
                        <span class="hearder_span">{{ $t("message.Grading") }}</span>
                      </template>
                      <template slot-scope="scope" style="text-align: center">{{
                        scope.row.rank_tag
                      }}</template>
                    </el-table-column>
                    <el-table-column label="Viewed impression">
                      <template slot="header" slot-scope="scope">
                        <span class="hearder_span">{{ $t("message.Viewed_Impression") }}</span>
                      </template>
                      <template slot-scope="scope" style="text-align: center">{{
                        Math.round((scope.row.IMP * scope.row.body_qty * repeatRatio(scope.row.body_qty))).toLocaleString('en-US')
                      }}</template>
                    </el-table-column>
                    <el-table-column>
                      <template slot="header" slot-scope="scope">
                        <span class="hearder_span">{{ $t("message.Viewed_Impression(Audience)") }}</span>
                      </template>
                      <template slot-scope="scope" style="text-align: center">{{
                        Math.round((scope.row.target_IMP * scope.row.body_qty * repeatRatio(scope.row.body_qty))).toLocaleString('en-US')
                      }}</template>
                    </el-table-column>
                    <el-table-column label="Bus body (qty)"> 
                      <template slot="header" slot-scope="scope">
                        <span class="hearder_span">{{ $t("message.Bus_body(qty)") }}</span>
                      </template>
                      <template slot-scope="scope">
                        <el-input-number size="mini" v-model="scope.row.body_qty" @change="handleChange(scope.row.body_qty,scope.row,'low')" :min="1" :max="20"></el-input-number>
                      </template>
                    </el-table-column>
                  </el-table>
                </div>
              </b-tab>
            </b-tabs>
          </div>
          <div style="clear: both;">
            <el-row type="flex" class="row-bg" justify="space-between">
              <el-col :span="4">
                <div style="background-color: #909399">
                  <p class="p_navi_button" v-on:click="goBack">
                    {{ $t("message.Back") }}
                  </p>
                </div>
              </el-col>

              <el-col :span="8">
                <div></div>
              </el-col>

              <el-col :span="4">
                <div style="background-color: #909399" @click="goNext">
                  <p class="p_navi_button">
                    {{ $t("message.Next") }}
                  </p>
                </div>
              </el-col>
            </el-row>
          </div>
        </div>
      </el-main>
    </el-container>
    <!-- <b-button @click="toggle">1234</b-button> -->
  </div>
</template>

<script>
import head_page from "./components/head_page.vue";
import head_menu from "./components/head_menu.vue";
import axios from "axios";
import _global from "./components/global.vue";
import 'bootstrap/dist/js/bootstrap.min.js'
export default {
  name: "package_selection",
  data() {
    return {
      num:1,
      lang: "en",
      chosen_city: "",
      loading:false,
      options: {},
      information: {},
      gender: null,
      age: null,
      spend_power: null,
      interest: null,
      poi: null,
      media_type: null,
      rank: null,
      campaignDate: null,
      campaignDate_YYMMDD: null,
      campaignDuration: null,
      poi_ba_label_selection_list: [],
      poi_ba_value_selection_list: [],
      dataInfo: {},
      busLineTotal:[],
      busLineTop: [],
      busLineMediumUp: [],
      busLineMediumDown: [],
      busLineLow: [],
      activeName: 'first',
      summaryTable: [
        {
          name: this.$t('message.Top_125+'),
          line_qty: 0,
          body_qty: 0,
          impression: 0,
          cluster_impression: 0,
        },
        {
          name: this.$t('message.Avg+_125_100'),
          line_qty: 0,
          body_qty: 0,
          impression: 0,
          cluster_impression: 0,
        },
        {
          name: this.$t('message.Avg-_100_75'),
          line_qty: 0,
          body_qty: 0,
          impression: 0,
          cluster_impression: 0,
        },
        {
          name: this.$t('message.Low_75-'),
          line_qty: 0,
          body_qty: 0,
          impression: 0,
          cluster_impression: 0,
        },
      ],
      selectedBusLineTop: [],
      selectedBusLineMediumUp: [],
      selectedBusLineMediumDown: [],
      selectedBusLineLow: [],
      selectedBusLine:[],
      busbody:[1,2,3,4,5],
      busLineTopT:[],
      busLineMediumUpT :[],
      busLineMediumDownT :[],
      busLineLowT :[],
      value_bus_line_total:'',
      value_bus_line_top:'',
      value_bus_line_medium_up:'',
      value_bus_line_medium_down:'',
      value_bus_line_low:'',
      tabIndex:0,
      value_search:'',
    };
  },
  computed:{
    chosen_city_shown: function () {
      let tmp = "message." + this.chosen_city;
      return this.$t(tmp);
    },
    localLang() {
      return this.$i18n.locale;
    }
  },
  watch: {
    localLang() {
      this.fillData_Info();
    }
  },
  components: {
    head_page,
    head_menu,
  },
  created() {
    if (JSON.parse(sessionStorage.getItem("User")) != null) {
      this.user = JSON.parse(sessionStorage.getItem("User"))
        .split(".")[0]
        .toUpperCase();
    }
    this.chosen_city = this.$route.query.chosen_city;
  },
  mounted() {
    this.lang = JSON.parse(sessionStorage.getItem("lang"));
    this.$refs.head_page.switchLang(this.lang);
    this.$refs.head_page.update_user_name();
    this.$i18n.locale = this.lang;
    this.fillData_Options();
    this.fillData_Info();
    //this.getBusLineDataFromAPI();
    if(sessionStorage.getItem('totalBusLine')!=null){
      // return from next page
      this.getBusLineDataFromLocal();
      this.getSelectedBusLineData()
    }else{
      this.getBusLineDataFromAPI();
    }

  if(this.$route.query.edit==1){
    this.selectedBusLineTop = this.$store.state.package.edit.package_selection.selectedBusLineTop;
    this.selectedBusLineMediumUp = this.$store.state.package.edit.package_selection.selectedBusLineMediumUp;
    this.selectedBusLineMediumDown = this.$store.state.package.edit.package_selection.selectedBusLineMediumDown;
    this.selectedBusLineLow = this.$store.state.package.edit.package_selection.selectedBusLineLow;
    this.selectedBusLine = this.$store.state.package.edit.package_selection.selectedBusLine;
    this.tables = this.$store.state.package.edit.package_selection.tables;
    }
  },
  updated(){
    if(sessionStorage.getItem('totalBusLine')!=null){
      this.toggleSelection(this.selectedBusLineTop,this.$refs.multipleTableTop,this.busLineTop)
      this.toggleSelection(this.selectedBusLineMediumUp,this.$refs.multipleTableMediumUp,this.busLineMediumUp)
      this.toggleSelection(this.selectedBusLineMediumDown,this.$refs.multipleTableMediumDown,this.busLineMediumDown)
      this.toggleSelection(this.selectedBusLineLow,this.$refs.multipleTableLow,this.busLineLow)
    }
  },
  methods: {
    localte(){
      window.location.href = '#'+this.value_search
    },
    handleBusLineTotalChange(val){
      this.value_search = val
      let res = this.busLineTop.map(x=>x.bus_id).indexOf(val)
      if (res == -1){
        res = this.busLineMediumUp.map(x=>x.bus_id).indexOf(val)
        this.tabIndex = 1
      }
      if (res == -1){
        res = this.busLineMediumDown.map(x=>x.bus_id).indexOf(val)
        this.tabIndex = 2
      }
      if (res == -1){
        res = this.busLineLow.map(x=>x.bus_id).indexOf(val)
        this.tabIndex = 3
      }
    },
    handleBusLineTopChange(val){
      window.location.href = '#'+val
    },
    updateSummaryTableLabel(){
      if (this.lang == 'en'){
        this.summaryTableTop='Top'
        this.summaryTableMediumUp='Avg+'
        this.summaryTableMediumDown='Avg-'
        this.summaryTableLow='Low'
      }
      else if(this.lang == 'cn'){
        this.summaryTableTop='极佳'
        this.summaryTableMediumUp='优秀'
        this.summaryTableMediumDown='较好'
        this.summaryTableLow='普通'
      }
    },

    stateFormat(row, column, cellValue) {
			cellValue += '';
			if (!cellValue.includes('.')) cellValue += '.';
			return cellValue.replace(/(\d)(?=(\d{3})+\.)/g, function ($0, $1) {
				return $1 + ',';
			}).replace(/\.$/, '');
		},
    getSummaries(param){
      const { columns, data } = param;
      const sums = []
      columns.forEach((column, index) => {
        if (index === 0) {
          if (this.lang == 'cn'){
            sums[index] = '合计';
          }
          else if (this.lang == 'en'){
            sums[index] = 'Summary';
          }
          return;
        }
        const values = data.map(item => Number(item[column.property]));
        if (!values.every(value => isNaN(value))) {
          sums[index] = values.reduce((prev, curr) => {
            const value = Number(curr);
            if (!isNaN(value)) {
              return prev + curr;
            } else {
              return prev;
            }
          }, 0);
          sums[index] = sums[index].toLocaleString('en-US');
        } else {
          sums[index] = 'N/A';
        }
      });

      return sums;
    },
    repeatRatio(bus_body){
      // Bus body repeat Ratio is x^0.75/x round to 3 demical
      return (Math.pow(bus_body,0.75)/bus_body).toFixed(3)

    },
    handleBulk(level){
      if (parseFloat(this.num).toString() == "NaN") {
  　　　　alert("请输入数字……")
  　　　　this.num=1
  　　}
      if (level == 'top'){
        for (let ele in this.busLineTop){
          this.busLineTop[ele].body_qty = parseFloat(this.num)
        }
        this.handleSelectionChangeTop(this.selectedBusLineTop) 
      }else if(level == 'mediumUp'){
        for (let ele in this.busLineMediumUp){
          this.busLineMediumUp[ele].body_qty = parseFloat(this.num)
        }
        this.handleSelectionChangeMediumUp(this.selectedBusLineMediumUp)
      }else if(level == 'mediumDown'){
        for (let ele in this.busLineMediumDown){
          this.busLineMediumDown[ele].body_qty = parseFloat(this.num)
        }
        this.handleSelectionChangeMediumDown(this.selectedBusLineMediumDown)
      }else if(level == 'low'){
        for (let ele in this.busLineLow){
          this.busLineLow[ele].body_qty = parseFloat(this.num)
        }
        this.handleSelectionChangeLow(this.selectedBusLineLow)
      }
      
    },
    handleChange(value,row,level) {
      
        if (level=="top"){
          let flag =false
          if(this.selectedBusLineTop.length>0){
            for (let ele of this.selectedBusLineTop){
              if (ele.bus_id == row.bus_id){
                flag=true
                break
              }
            }
          }
          if (flag){
            this.handleSelectionChangeTop(this.selectedBusLineTop)
          }
          else{
            this.$refs.multipleTableTop.toggleRowSelection(row)
          }
        }else if(level=="mediumUp"){
          let flag =false
          if(this.selectedBusLineMediumUp.length>0){
            for (let ele of this.selectedBusLineMediumUp){
              if (ele.bus_id == row.bus_id){
                flag=true
                break
              }
            }
          } 
          if (flag){
            this.handleSelectionChangeMediumUp(this.selectedBusLineMediumUp)
          }
          else{
            this.$refs.multipleTableMediumUp.toggleRowSelection(row)
          }
        }else if(level=="mediumDown"){
          let flag =false
          if(this.selectedBusLineMediumDown.length>0){
            for (let ele of this.selectedBusLineMediumDown){
              if (ele.bus_id == row.bus_id){
                flag=true
                break
              }
            }
          }
          if (flag){
            this.handleSelectionChangeMediumDown(this.selectedBusLineMediumDown)
          }
          else{
            this.$refs.multipleTableMediumDown.toggleRowSelection(row)
          }
        }else if(level=="low"){
          let flag =false
          if(this.selectedBusLineLow.length>0){
            for (let ele of this.selectedBusLineLow){
              if (ele.bus_id == row.bus_id){
                flag=true
                break
              }
            }
          }
          if (flag){
            this.handleSelectionChangeLow(this.selectedBusLineLow)
          }
          else{

            this.$refs.multipleTableLow.toggleRowSelection(row)
          }
        }

    },
    goBack: function (event) {
      let lang = JSON.parse(sessionStorage.getItem("lang"));
      let user = JSON.parse(sessionStorage.getItem("User"));
      let UserAuthority = JSON.parse(sessionStorage.getItem("UserAuthority"));
      sessionStorage.clear();
      sessionStorage.setItem("lang", JSON.stringify(lang));
      sessionStorage.setItem("User", JSON.stringify(user));
      sessionStorage.setItem("UserAuthority", JSON.stringify(UserAuthority));
      //set null when out of package
      this.$store.state.package.edit = {}
      this.$router.push({
        path: "/information",
        query: {
          chosen_city: this.$route.query.chosen_city,
        },
      });
    },
    goHome: function (event) {
      this.$router.push({
        path: "/choose_city",
      });
      let lang = JSON.parse(sessionStorage.getItem("lang"));
      let user = JSON.parse(sessionStorage.getItem("User"));
      let UserAuthority = JSON.parse(sessionStorage.getItem("UserAuthority"));
      sessionStorage.clear();
      sessionStorage.setItem("lang", JSON.stringify(lang));
      sessionStorage.setItem("User", JSON.stringify(user));
      sessionStorage.setItem("UserAuthority", JSON.stringify(UserAuthority));
      //set null when out of package
      this.$store.state.package.edit = {}
    },
    fillData_Options() {
      this.options = this.$store.state.package.Data_Options;
      //this.options = JSON.parse(sessionStorage.getItem('Data_Options'));
    },
    fillData_Info() {
      this.information = this.$store.state.package.Data_Information;
      //this.information = JSON.parse(sessionStorage.getItem('Data_Information'));
      let gender = this.information["data_audience"].value_gender;
      let age = this.information["data_audience"].value_age;
      let spend_power = this.information["data_audience"].value_spend_power;
      let interest = this.information["data_audience"].value_interest;
      let gender_options = this.options["audience_options"]["gender_options"];
      let age_options = this.options["audience_options"]["age_options"];
      let spend_power_options = this.options["audience_options"][
        "spend_power_options"
      ];
      let interest_options = this.options["audience_options"][
        "interest_options"
      ];

      this.poi_ba_value_selection_list = this.information[
        "poi_ba_value_selection_list"
      ];
      let poi_ba_label_selection_list = this.information[
        "poi_ba_label_selection_list"
      ];

      this.gender = this.changeDataToText(gender, gender_options);
      this.age = this.changeDataToText(age, age_options);
      this.spend_power = this.changeDataToText(
        spend_power,
        spend_power_options
      );
      this.interest = this.changeDataToText(interest, interest_options);
      this.poi = this.changeDataToText_poi(this.information["data_poi"]);
      this.media_type = this.changeDataToText(
        this.information["data_media_rank"].value_media_format,
        this.options["media_rank_options"].media_format_options
      );
      this.rank = this.changeDataToText(
        this.information["data_media_rank"].value_rank,
        this.options["media_rank_options"].rank_options
      );
      if (this.rank != "") this.ifRank = true;

      this.campaignDate = new Date(this.information.date)
      this.campaignDate_YYMMDD = this.campaignDate.getFullYear()+'/'+(Number(this.campaignDate.getMonth())+1).toString()+'/'+this.campaignDate.getDate();
      this.campaignDuration = this.information.value_duration;

      this.poi_ba_label_selection_list = this.changeDataToText_PoiSearch(
        poi_ba_label_selection_list
      );
    },

    changeDataToText_poi(poi) {
      let str = "";
      if (poi.checked_business == true) {
        str = str + this.$t("message.BUSINESS") + " ";
      }
      if (poi.checked_entertainment == true) {
        str = str + this.$t("message.ENTERTAINEMENT") + " ";
      }
      if (poi.checked_living == true) {
        str = str + this.$t("message.LIVING") + " ";
      }
      if (poi.checked_trip == true) {
        str = str + this.$t("message.TRIP");
      }
      return str;
    },

    changeDataToText(data, options) {
      let obj = "";
      if (this.$i18n.locale == "en") {
        if (typeof data == "number") {
          for (let i = 0; i < options.length; i++) {
            if (Number(options[i].value) == data) {
              obj = obj + options[i].label;
            }
          }
        } else if (typeof data == "object") {
          if (data.length > 1) {
            data = data.sort();
          }

          for (let d in data) {
            for (let op in options) {
              if (Number(data[d]) == Number(options[op].value)) {
                obj = obj + String(options[op].label) + " ";
              }
            }
          }
        }
      } else if (this.$i18n.locale == "cn") {
        if (typeof data == "number") {
          for (let i = 0; i < options.length; i++) {
            if (Number(options[i].value) == data) {
              obj = obj + options[i].label_cn;
            }
          }
        } else if (typeof data == "object") {
          if (data.length > 1) {
            data = data.sort();
          }

          for (let d in data) {
            for (let op in options) {
              if (Number(data[d]) == Number(options[op].value)) {
                obj = obj + String(options[op].label_cn) + " ";
              }
            }
          }
        }
      }
      return obj;
    },
    changeDataToText_PoiSearch(poi_ba_label_selection_list) {
      let poi_ba_label_selection_list_text = "";
      for (let index in poi_ba_label_selection_list) {
        poi_ba_label_selection_list_text =
          poi_ba_label_selection_list_text +
          poi_ba_label_selection_list[index] +
          " ";
      }
      return poi_ba_label_selection_list_text;
    },

    getBusLineDataFromAPI() {
      let data = this.$store.state.package.Data_Information;
      delete data.media_format_options;
      let api_url =
        _global.serverSrc +
        "/bus_line_rating/?format=json&chosen_city=" +
        this.$route.query.chosen_city;
      var _self = this;

      let arr = [];
      Object.keys(data).forEach((v) => {
        let o = {};
        o[v] = data[v];
        arr.push(o);
      });
      let obj = {
        'email': JSON.parse(sessionStorage.getItem('User')),
        'dataInfo': arr
      }
      this.$axios
        .post(api_url, obj)
        .then((response) => {
          for (let ele in response.data.bus_line_rating) {
            let index = response.data.bus_line_rating[ele]["value_rating"];
            // default bus qunatity is 1
            response.data.bus_line_rating[ele]['body_qty']=1
            if (index <= 1.5 && index >= 1.25) {
              response.data.bus_line_rating[ele]['body_qty']=1
              _self.busLineTop.push(response.data.bus_line_rating[ele]);
            } else if (index < 1.25 && index >= 1) {
              _self.busLineMediumUp.push(response.data.bus_line_rating[ele]);
            } else if (index < 1 && index >= 0.75) {
              _self.busLineMediumDown.push(response.data.bus_line_rating[ele]);
            } else {
              _self.busLineLow.push(response.data.bus_line_rating[ele]);
            }
          }
          _self.busLineTopT = JSON.parse(JSON.stringify(_self.busLineTop));
          _self.busLineMediumUpT = JSON.parse(JSON.stringify(_self.busLineMediumUp));
          _self.busLineMediumDownT = JSON.parse(JSON.stringify(_self.busLineMediumDown));
          _self.busLineLowT = JSON.parse(JSON.stringify(_self.busLineLow));
          if (this.$route.query.edit==1){
            _self.busLineTop = this.selectedBusLineTop
            _self.busLineMediumUp =this.selectedBusLineMediumUp
            _self.busLineMediumDown =this.selectedBusLineMediumDown
            _self.busLineLow = this.selectedBusLineLow 
          }
          
          _self.busLineTotal = _self.busLineTop.concat(_self.busLineMediumUp,_self.busLineMediumDown,_self.busLineLow)
        })
        .catch((e) => {
        });
    },
    getBusLineDataFromLocal(){
      let obj = JSON.parse(sessionStorage.getItem('totalBusLine'))
      this.busLineTop = obj.busLineTop
      this.busLineMediumUp = obj.busLineMediumUp
      this.busLineMediumDown = obj.busLineMediumDown
      this.busLineLow = obj.busLineLow
    },
    getSelectedBusLineData(){
      this.selectedBusLineTop = this.$store.state.package.package_selection.selectedBusLineTop
      this.selectedBusLineMediumUp = this.$store.state.package.package_selection.selectedBusLineMediumUp
      this.selectedBusLineMediumDown = this.$store.state.package.package_selection.selectedBusLineMediumDown
      this.selectedBusLineLow = this.$store.state.package.package_selection.selectedBusLineLow

      // let obj = JSON.parse(sessionStorage.getItem('selectedBusLine'))
      // this.selectedBusLineTop = obj.selectedBusLineTop
      // this.selectedBusLineMediumUp = obj.selectedBusLineMediumUp
      // this.selectedBusLineMediumDown = obj.selectedBusLineMediumDown
      // this.selectedBusLineLow = obj.selectedBusLineLow
    },
    toggleSelection(selectedLines,tableName,totalLines) {
        if (selectedLines) {
          selectedLines.forEach(selectedLine => {
            tableName.toggleRowSelection(totalLines.find(item=>{
              return selectedLine.bus_id == item.bus_id
            }),true);
          });
        } else {
          tableName.clearSelection();
        }
    },

    handleSelectionChangeTop(val) {
      this.selectedBusLineTop = val;
      this.summaryTable[0].line_qty = this.selectedBusLineTop.length;
      let summaryImpression = 0;
      let summaryClusterImpression = 0
      let summaryBodyQty = 0
      for (let ele of this.selectedBusLineTop) {
        summaryImpression += Math.round(ele.IMP * ele.body_qty * this.repeatRatio(ele.body_qty))
        summaryClusterImpression += Math.round(ele.target_IMP *ele.body_qty * this.repeatRatio(ele.body_qty))
        summaryBodyQty += ele.body_qty
      }
      this.summaryTable[0].impression = summaryImpression;
      this.summaryTable[0].cluster_impression = summaryClusterImpression;
      this.summaryTable[0].body_qty = summaryBodyQty;
    },
    handleSelectionChangeMediumUp(val) {
      this.selectedBusLineMediumUp = val;
      this.summaryTable[1].line_qty = this.selectedBusLineMediumUp.length;
      let summaryImpression = 0;
      let summaryClusterImpression = 0
      let summaryBodyQty = 0
      for (let ele of this.selectedBusLineMediumUp) {
        summaryImpression += Math.round(ele.IMP * ele.body_qty * this.repeatRatio(ele.body_qty))
        summaryClusterImpression += Math.round(ele.target_IMP * ele.body_qty * this.repeatRatio(ele.body_qty))
        summaryBodyQty += ele.body_qty
      }
      this.summaryTable[1].impression = summaryImpression;
      this.summaryTable[1].cluster_impression = summaryClusterImpression;
      this.summaryTable[1].body_qty = summaryBodyQty;
    },
    handleSelectionChangeMediumDown(val) {
      this.selectedBusLineMediumDown = val;
      this.summaryTable[2].line_qty = this.selectedBusLineMediumDown.length;
      let summaryImpression = 0;
      let summaryClusterImpression = 0
      let summaryBodyQty = 0
      for (let ele of this.selectedBusLineMediumDown) {
        summaryImpression += Math.round(ele.IMP * ele.body_qty * this.repeatRatio(ele.body_qty))
        summaryClusterImpression += Math.round(ele.target_IMP * ele.body_qty * this.repeatRatio(ele.body_qty))
        summaryBodyQty += ele.body_qty
      }
      this.summaryTable[2].impression = summaryImpression;
      this.summaryTable[2].cluster_impression = summaryClusterImpression;
      this.summaryTable[2].body_qty = summaryBodyQty;
    },
    handleSelectionChangeLow(val) {
      this.selectedBusLineLow = val;
      this.summaryTable[3].line_qty = this.selectedBusLineLow.length;
      let summaryImpression = 0;
      let summaryClusterImpression = 0
      let summaryBodyQty = 0
      for (let ele of this.selectedBusLineLow) {
        summaryImpression += Math.round(ele.IMP * ele.body_qty * this.repeatRatio(ele.body_qty))
        summaryClusterImpression += Math.round(ele.target_IMP * ele.body_qty * this.repeatRatio(ele.body_qty))
        summaryBodyQty += ele.body_qty
      }
      this.summaryTable[3].impression = summaryImpression;
      this.summaryTable[3].cluster_impression = summaryClusterImpression;
      this.summaryTable[3].body_qty = summaryBodyQty;
    },
    updateQty(data,val){
      //this.handleSelectionChangeTop(val)
    },
    
    goNext(){
      //存数据
      this.storeTotalSelectedBusLine(this.selectedBusLineTop)
      this.storeTotalSelectedBusLine(this.selectedBusLineMediumUp)
      this.storeTotalSelectedBusLine(this.selectedBusLineMediumDown)
      this.storeTotalSelectedBusLine(this.selectedBusLineLow)
      this.$store.state.package.package_selection.selectedBusLine = this.selectedBusLine
      this.$store.state.package.package_selection.selectedBusLineTop=this.selectedBusLineTop
      this.$store.state.package.package_selection.selectedBusLineMediumUp=this.selectedBusLineMediumUp
      this.$store.state.package.package_selection.selectedBusLineMediumDown=this.selectedBusLineMediumDown
      this.$store.state.package.package_selection.selectedBusLineLow=this.selectedBusLineLow
      this.$store.state.package.package_selection.campaignDuration=this.campaignDuration
      this.$store.state.package.package_selection.media_type=this.media_type

      
      let optionGrade = []
      for (let ele in this.options.media_rank_options.rank_options){
        optionGrade.push(this.options.media_rank_options.rank_options[ele].label)
      }

      let distributionGrade = this.calculationDistribution(this.selectedBusLine,'rank_tag',optionGrade)
      this.$store.state.package.package_selection.distributionGrade = distributionGrade
      let distributionIndex = {'Top':this.selectedBusLineTop.length,'Medium up':this.selectedBusLineMediumUp.length,'Medium Down':this.selectedBusLineMediumDown.length,'Low':this.selectedBusLineLow.length}
      this.$store.state.package.package_selection.distributionIndex = distributionIndex

      //Save total bus line data to session storage in case return from next page
      let obj_t = {}
      obj_t.busLineTop = this.busLineTop
      obj_t.busLineMediumUp = this.busLineMediumUp
      obj_t.busLineMediumDown = this.busLineMediumDown
      obj_t.busLineLow = this.busLineLow
      sessionStorage.setItem('totalBusLine', JSON.stringify(obj_t))

      this.$router.push({
        path: '/package_cost',
        query: {
          chosen_city: this.$route.query.chosen_city
        }
      })
    },
    storeTotalSelectedBusLine(selectedGroup){

      for (let ele in selectedGroup){
        this.selectedBusLine.push(selectedGroup[ele])
      }
    },
    calculationDistribution(totalSelectionBusLine,columnName,optionList){
      let distribution = {}
      for(let ele in optionList){
        let option = optionList[ele]
          distribution[option] = 0
      }
      for (let ele in totalSelectionBusLine){
        let key = totalSelectionBusLine[ele][columnName]
        if (distribution.hasOwnProperty(key)){
          distribution[key] += 1
        }
      }
      
      return distribution
    },
  },
};
</script>

<style scoped>
  .is-active{
    user-select: none;
  }
  .hearder_span{
    text-align: center;
  }
</style>